import type { ConcernType } from '../services/api/coachPortal';

export interface ConcernTypeConfig {
  label: string;
  description: string;
}

export const CONCERN_TYPE_CONFIG: Record<ConcernType, ConcernTypeConfig> = {
  low_engagement: {
    label: 'Low Engagement',
    description: 'Not participating or contributing in sessions',
  },
  attendance_issues: {
    label: 'Attendance Issues',
    description: 'Frequently late, leaving early, or missing sessions',
  },
  disruptive_behavior: {
    label: 'Disruptive Behavior',
    description: 'Behavior that disrupts the group dynamic',
  },
  personal_crisis: {
    label: 'Personal Crisis',
    description: 'Appears to be dealing with personal challenges',
  },
  conflict_with_group_member: {
    label: 'Conflict with Group Member',
    description: 'Interpersonal conflict within the group',
  },
  technical_difficulties: {
    label: 'Technical Difficulties',
    description: 'Recurring technical issues affecting participation',
  },
  struggling_with_content: {
    label: 'Struggling with Content',
    description: 'Having difficulty understanding or applying session material',
  },
  not_completing_prework: {
    label: 'Not Completing Prework',
    description: 'Consistently not completing pre-session assignments',
  },
  flight_risk: {
    label: 'Flight Risk',
    description: 'May drop out of the program',
  },
  other: {
    label: 'Other',
    description: 'Other concern not listed above',
  },
};

export const CONCERN_TYPE_OPTIONS = Object.entries(CONCERN_TYPE_CONFIG).map(([value, config]) => ({
  value: value as ConcernType,
  label: config.label,
}));
